import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RenderFilterForm from "../../utils/filterForm";
import {loadOccupationsForSelect} from "../../actions/Occupation/forSelect";

class FilterForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    error: PropTypes.string
  };

  componentDidMount() {
    this.props.loadOccupationsForSelect();
  }

  render() {
    const fields = [
      {'name': 'id', 'label': 'ID', 'placeholder': 'ID', 'type': 'number'},
      {'name': 'name', 'label': 'Name', 'placeholder': 'Name', 'type': 'text'},
      {'name': 'occupation', 'label': 'Occupation', 'placeholder': 'Occupation', 'type': 'selectSearch', 'options': this.props.occupations},
    ];

    return (
      <RenderFilterForm {...this.props} fields={fields} />
    );
  }
}

const mapStateToProps = state => {
  let occupations = state.occupation.forSelect.retrieved;

  return { occupations };
};


const mapDispatchToProps = dispatch => ({
  loadOccupationsForSelect: () => dispatch(loadOccupationsForSelect('@id')),
});

FilterForm = reduxForm({
  form: 'specialties',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(FilterForm);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterForm);
